// // https://vuex.vuejs.org/en/modules.html

// const requireModule = require.context('.', true, /(?!__)\.js$/)
// const modules = {}

// requireModule.keys().forEach(fileName => {
//   if (fileName === './index.js' || fileName.includes('.spec.')) return

//   // Replace ./ and .js
//   const path = fileName.replace(/(\.\/|\.js)/g, '')
//   const [moduleName, imported] = path.split('/')

//   if (!modules[moduleName]) {
//     modules[moduleName] = {
//       namespaced: true
//     }
//   }

//   modules[moduleName][imported] = requireModule(fileName).default
// })

// export default modules

import auth from './auth'
import app from './app'
import display from './display'
import customers from './customers'
import list from './list'
import dashboard from './dashboard'
import groups from './groups'
import tankTypes from './tankTypes'

export default {
  auth: {
    ...auth, namespaced: true
  },
  app: {
    ...app, namespaced: true
  },
  display: {
    ...display, namespaced: true
  },
  dashboard: {
    ...dashboard, namespaced: true
  },
  customers: {
    ...customers, namespaced: true
  },
  list: {
    ...list, namespaced: true
  },
  groups: {
    ...groups, namespaced: true
  },
  tankTypes: {
    ...tankTypes, namespaced: true
  }
}
